<template>
  <router-view></router-view>
</template>

<script>
// import "@/assets/css/user.css";
export default {
  name: "UserView",
};
</script>
